import {
  BulkDownloadFoldersRequest,
  BulkDownloadFoldersResponse,
} from "@safetyculture/s12-apis-connect-web/s12/directory/v1/directory_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type BulkDownloadFoldersParams = {
  OrgId: string;
  IncludeDeleted: boolean;
};

export const BulkDownloadFoldersAPI = async (
  { OrgId, IncludeDeleted }: BulkDownloadFoldersParams,
  headers: Record<RequestMetadata, string>
): Promise<BulkDownloadFoldersResponse> => {
  const req = new BulkDownloadFoldersRequest({
    orgId: OrgId,
    includeDeleted: IncludeDeleted,
    domain: "site",
  });

  return supportServiceConnectClient.bulkDownloadFolders(req, {
    headers,
  });
};
